import DashboardIcon from "../../../assets/Icons/Dashboard Grey.png";
import AudioIcon from "../../../assets/Icons/Audio Note Grey.png";
import VideoIcon from "../../../assets/Icons/Video Grey.png";
import ConferenceIcon from "../../../assets/Icons/Conference Grey.png";
import LightsIcon from "../../../assets/Icons/Lights Grey.png";
import CurtainsIcon from "../../../assets/Icons/Curtains Grey.png";
import ClimateIcon from "../../../assets/Icons/Climate Grey.png";
import SecurityIcon from "../../../assets/Icons/Security Grey.png";
import AnalyticsIcon from "../../../assets/Icons/Analytics Grey.png";
import NotificationsIcon from "../../../assets/Icons/Notification Grey.png";
import LogoutIcon from "../../../assets/Icons/Logout-Grey.png";

import DashboardIconWhite from "../../../assets/Icons/Dashboard-White.png";
import AudioIconWhite from "../../../assets/Icons/Audio Note White.png";
import VideoIconWhite from "../../../assets/Icons/Video White.png";
import ConferenceIconWhite from "../../../assets/Icons/Conference-White.png";
import LightsIconWhite from "../../../assets/Icons/Lights White.png";
import CurtainsIconWhite from "../../../assets/Icons/Curtains White.png";
import ClimateIconWhite from "../../../assets/Icons/Climate White.png";
import SecurityIconWhite from "../../../assets/Icons/Security White.png";
import AnalyticsIconWhite from "../../../assets/Icons/Analytics White.png";
import NotificationsIconWhite from "../../../assets/Icons/Notification White.png";
import LogoutIconWhite from "../../../assets/Icons/Logout-White.png";

import { Pages } from "../../Utils/Types";
export const userNameStyle = {
  fontWeight: 400,
  fontSize: "14px",
};

export const role = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
};
export interface MenuItem {
  name: Pages;
  icon: string;
  greyIcon: string;
  onlyAdmin: boolean;
  id: number;
}
export const sideBarMenu: MenuItem[] = [
  {
    name: Pages.Dashboard,
    icon: DashboardIcon,
    greyIcon: DashboardIconWhite,
    onlyAdmin: false,
    id: 0,
  },
  {
    name: Pages.Audio,
    icon: AudioIcon,
    greyIcon: AudioIconWhite,
    onlyAdmin: false,
    id: 1,
  },
  {
    name: Pages.Video,
    icon: VideoIcon,
    greyIcon: VideoIconWhite,
    onlyAdmin: false,
    id: 2,
  },
  {
    name: Pages.Conference,
    icon: ConferenceIcon,
    greyIcon: ConferenceIconWhite,
    onlyAdmin: false,
    id: 3,
  },
  {
    name: Pages.Lights,
    icon: LightsIcon,
    greyIcon: LightsIconWhite,
    onlyAdmin: false,
    id: 4,
  },
  {
    name: Pages.Curtains,
    icon: CurtainsIcon,
    greyIcon: CurtainsIconWhite,
    onlyAdmin: false,
    id: 5,
  },
  {
    name: Pages.Climate,
    icon: ClimateIcon,
    greyIcon: ClimateIconWhite,
    onlyAdmin: false,
    id: 6,
  },
  {
    name: Pages.Security,
    icon: SecurityIcon,
    greyIcon: SecurityIconWhite,
    onlyAdmin: false,
    id: 7,
  },
  {
    name: Pages.Analytics,
    icon: AnalyticsIcon,
    greyIcon: AnalyticsIconWhite,
    onlyAdmin: false,
    id: 8,
  },
  {
    name: Pages.Notifications,
    icon: NotificationsIcon,
    greyIcon: NotificationsIconWhite,
    onlyAdmin: false,
    id: 9,
  },
  {
    name: Pages.Logout,
    icon: LogoutIcon,
    greyIcon: LogoutIconWhite,
    onlyAdmin: false,
    id: 10,
  },
];
